<template>
  <h1>CountrieList</h1>
</template>

<script>
export default {
  name: "CountrieList"
};
</script>

<style></style>
